export type TimezoneOption = { value: string; label: string; group?: string };

// Curated top list (keeps the UI tight)
export const POPULAR_TIMEZONES: TimezoneOption[] = [
  { value: "UTC", label: "UTC" },

  { value: "America/Los_Angeles", label: "Pacific Time (US & Canada)" },
  { value: "America/Denver", label: "Mountain Time (US & Canada)" },
  { value: "America/Chicago", label: "Central Time (US & Canada)" },
  { value: "America/New_York", label: "Eastern Time (US & Canada)" },

  { value: "Europe/London", label: "London (UK)" },
  { value: "Europe/Paris", label: "Central Europe (Paris)" },
  { value: "Europe/Berlin", label: "Central Europe (Berlin)" },

  { value: "Asia/Dubai", label: "Dubai (UAE)" },
  { value: "Asia/Kolkata", label: "India (Kolkata)" },
  { value: "Asia/Singapore", label: "Singapore" },
  { value: "Asia/Tokyo", label: "Tokyo (Japan)" },

  { value: "Australia/Sydney", label: "Sydney (Australia)" },
];

// Full IANA list (flat array to search from)
export const ALL_TIMEZONES: TimezoneOption[] = [
  // --- Africa
  { value: "Africa/Cairo", label: "Africa/Cairo" },
  { value: "Africa/Johannesburg", label: "Africa/Johannesburg" },
  { value: "Africa/Lagos", label: "Africa/Lagos" },
  { value: "Africa/Nairobi", label: "Africa/Nairobi" },

  // --- America (sample; add more over time)
  { value: "America/Anchorage", label: "America/Anchorage" },
  { value: "America/Argentina/Buenos_Aires", label: "America/Argentina/Buenos_Aires" },
  { value: "America/Chicago", label: "America/Chicago" },
  { value: "America/Denver", label: "America/Denver" },
  { value: "America/Halifax", label: "America/Halifax" },
  { value: "America/Los_Angeles", label: "America/Los_Angeles" },
  { value: "America/Mexico_City", label: "America/Mexico_City" },
  { value: "America/New_York", label: "America/New_York" },
  { value: "America/Phoenix", label: "America/Phoenix" },
  { value: "America/Sao_Paulo", label: "America/Sao_Paulo" },
  { value: "America/St_Johns", label: "America/St_Johns" },
  { value: "America/Toronto", label: "America/Toronto" },
  { value: "America/Vancouver", label: "America/Vancouver" },

  // --- Asia
  { value: "Asia/Bangkok", label: "Asia/Bangkok" },
  { value: "Asia/Dhaka", label: "Asia/Dhaka" },
  { value: "Asia/Dubai", label: "Asia/Dubai" },
  { value: "Asia/Hong_Kong", label: "Asia/Hong_Kong" },
  { value: "Asia/Jakarta", label: "Asia/Jakarta" },
  { value: "Asia/Jerusalem", label: "Asia/Jerusalem" },
  { value: "Asia/Kolkata", label: "Asia/Kolkata" },
  { value: "Asia/Seoul", label: "Asia/Seoul" },
  { value: "Asia/Shanghai", label: "Asia/Shanghai" },
  { value: "Asia/Singapore", label: "Asia/Singapore" },
  { value: "Asia/Tokyo", label: "Asia/Tokyo" },

  // --- Europe
  { value: "Europe/Amsterdam", label: "Europe/Amsterdam" },
  { value: "Europe/Athens", label: "Europe/Athens" },
  { value: "Europe/Berlin", label: "Europe/Berlin" },
  { value: "Europe/Istanbul", label: "Europe/Istanbul" },
  { value: "Europe/London", label: "Europe/London" },
  { value: "Europe/Madrid", label: "Europe/Madrid" },
  { value: "Europe/Paris", label: "Europe/Paris" },
  { value: "Europe/Rome", label: "Europe/Rome" },
  { value: "Europe/Warsaw", label: "Europe/Warsaw" },

  // --- Pacific / Australia
  { value: "Australia/Perth", label: "Australia/Perth" },
  { value: "Australia/Sydney", label: "Australia/Sydney" },
  { value: "Pacific/Auckland", label: "Pacific/Auckland" },
];

export const DEFAULT_TIMEZONE = "America/Denver";

// For validation (Signup + Settings actions)
export const ALL_TIMEZONE_VALUES = new Set([
  ...POPULAR_TIMEZONES.map((t) => t.value),
  ...ALL_TIMEZONES.map((t) => t.value),
]);

export function isValidTimezone(tz: string) {
  return ALL_TIMEZONE_VALUES.has(tz);
}
